import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import httpService from "../../../../services/httpServices/httpServices";
import helperNumber from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import helperTime from "../../../../helpers/time";
import StateSiteUserPublisher from "../../site/StateSiteUserPublisher";
import PublisherConstants from "./PublisherConstants";
import Pagination from "../../../partials/content/Pagination";

export default function AllPublisher() {
  const [allSitePublisher, setAllSitePublisher] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [urlWebSitePublisherSearchFilter, setUrlWebSitePublisherSearchFilter] =
    useState();

  useEffect(() => {
    getAllSitePublisher();
  }, [currentPage, urlWebSitePublisherSearchFilter]);

  const getAllSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allSitePublisher = await sendRequestGetAllSitePublisher(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allSitePublisher) {
      return;
    }

    setAllSitePublisher(allSitePublisher.site_publisher);
    setCountPage(allSitePublisher.count_page);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (urlWebSitePublisherSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&url=${urlWebSitePublisherSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllSitePublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderRequest();
    let allSitePublisher;
    try {
      allSitePublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/publisher/all/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allSitePublisher.data.data;
  };

  const generateTableSitePublisher = () => {
    return (
      <>
        <div className="alert alert-warning d-flex">
          <p>برای تعیین وضعیت و حالت سایت نمایش دهنده از این</p>
          <p className="px-2">
            <a
              href={`${process.env.REACT_APP_DOMAIN_ADVERTISER}/user/all`}
              target="_blank"
            >
              لینک
            </a>
          </p>
          <p> اقدام کنید.</p>
        </div>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در آدرس سایت </label>
              </div>
              <div>
                <input
                  onKeyUp={(e) =>
                    setUrlWebSitePublisherSearchFilter(e.target.value)
                  }
                  className="form-control"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>شماره کاربر</td>
                <td>دامنه سایت</td>
                <td>وضعیت</td>
                <td>حالت</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allSitePublisher.map((sitePublisher, index) => {
                let classBadgeStatePage;
                switch (sitePublisher.usp_state) {
                  case PublisherConstants.statusSiteUserPublisher.PENDING:
                    classBadgeStatePage = "badge-warning";
                    break;
                  case PublisherConstants.statusSiteUserPublisher.CONFIRM:
                    classBadgeStatePage = "badge-info";
                    break;
                  case PublisherConstants.statusSiteUserPublisher.REJECT:
                    classBadgeStatePage = "badge-danger";
                    break;
                }

                return (
                  <tr>
                    <td>{helperNumber.toPersianNum(index + 1)}</td>
                    <td>{sitePublisher.usp_id}</td>
                    <td>{sitePublisher.usp_user_id}</td>
                    <td className="text-left">
                      <a target="_blank" href={sitePublisher.usp_url}>
                        {sitePublisher.usp_url}
                      </a>
                    </td>
                    <td>
                      <span className={`badge ${classBadgeStatePage}`}>
                        {
                          PublisherConstants.getStatusSiteUserPublisherString()[
                            sitePublisher.usp_state
                          ]
                        }
                      </span>
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          sitePublisher.usp_active == 1
                            ? "badge-success"
                            : "badge-warning"
                        }`}
                      >
                        {
                          PublisherConstants.getActiveSiteUserPublisherString()[
                            sitePublisher.usp_active
                          ]
                        }
                      </span>
                    </td>
                    <td>
                      {helperNumber.toPersianNum(
                        sitePublisher.usp_created_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            sitePublisher.usp_created_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      <span>
                        <Link
                          to={`/page/manage/all/publisher/${sitePublisher.usp_id}`}
                          className="btn btn-primary"
                        >
                          نمایش صفحات
                        </Link>
                      </span>
                      <span className="pr-2">
                        <Link
                          className="btn btn-info"
                          to={`/position/manage/independent/publisher/${sitePublisher.usp_id}`}
                        >
                          نمایش جایگاه های مستقل
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-publisher" activeItem="all-mange-publisher" />

      <div className="content-wrapper">
        <TitleBar title="لیست نمایش دهندگان" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {allSitePublisher.length === 0 &&
              urlWebSitePublisherSearchFilter == null ? (
                <></>
              ) : (
                generateTableSitePublisher()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
